<div class="inner-content">
  <ion-toolbar color="primary">
    <ion-title id="modal-title" class="ion-text-center ion-no-padding ion-text-uppercase fs-pt-16">{{ 'shared.recover_password.title' | transloco }}</ion-title>
  </ion-toolbar>

  <br>

    <div class="ion-padding-horizontal">
      <div class="ion-padding" style="text-align: center">
        <ion-label class="fs-pt-14">{{ 'shared.recover_password.message' | transloco }}</ion-label>
      </div>

      <ion-item>
        <!--<ion-label position="floating">E-mail o username</ion-label>-->
        <ion-input [formControl]="ctrlEmail()" [label]="'shared.recover_password.emailLabel' | transloco" labelPlacement="floating"
          [placeholder]="'shared.recover_password.emailPlaceholder' | transloco"
          type="email">
        </ion-input>
        <ion-icon name="person-circle-outline" slot="start" color="primary"></ion-icon>
        @if (ctrlEmail().touched && ctrlEmail().hasError('pattern')) {
          <ion-note color="danger" class="ion-text-justify"
            slot="error">
            {{ 'shared.recover_password.emailPatternError' | transloco }}
          </ion-note>
        }
      </ion-item>
    </div>

    @if (errorMessage) {
      <div class="ion-padding-horizontal ion-padding-bottom">
        <ion-note color="danger" role="alert" class="ion-text-justify">{{errorMessage}}</ion-note>
      </div>
    }

    <ion-grid>
      <ion-row class="ion-justify-content-center ion-align-items-center">
        <ion-col size-sm="12" size-xl="6" size-md="8">
          <ion-button  class="ion-margin-top ion-text-uppercase"
            [disabled]="ctrlEmail().invalid"
            color="primary" (click)="confirmRecoverPassword()" fill="solid"
          expand="block">{{ 'shared.recover_password.submitButton' | transloco }}</ion-button>

          @if (isCancelButtonVisible) {
            <ion-button class="ion-margin-top ion-text-uppercase"
              color="danger" (click)="cancel()" fill="solid"
            expand="block">{{ 'common.action.cancel' | transloco }}</ion-button>
          }
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
